export default "__VITE_ASSET__DPIzaQ9s__"